import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage, defineMessages } from 'react-intl';

import { TokenName } from 'components/token/TokenName';

import { SectionTitle } from '../ui';
import { TransactionsPrimaryOffer_tokenPrimaryOffer } from './__generated__/index.graphql';

const messages = defineMessages({
  detail: {
    id: 'TransactionsHistoryPrimaryOffer.detail',
    defaultMessage: 'Cards in pack',
  },
});

type Props = {
  tokenPrimaryOffer: TransactionsPrimaryOffer_tokenPrimaryOffer;
};

export const TransactionsPrimaryOffer = ({ tokenPrimaryOffer }: Props) => {
  return (
    <>
      <SectionTitle>
        <FormattedMessage {...messages.detail} />
      </SectionTitle>
      {tokenPrimaryOffer.cards.map(nft => (
        <TokenName key={nft.slug} card={nft} withLink />
      ))}
    </>
  );
};

TransactionsPrimaryOffer.fragments = {
  tokenPrimaryOffer: gql`
    fragment TransactionsPrimaryOffer_tokenPrimaryOffer on TokenPrimaryOffer {
      id
      cards: anyCards {
        slug
        ...TokenName_anyCard
      }
    }
    ${TokenName.fragments.anyCard}
  ` as TypedDocumentNode<TransactionsPrimaryOffer_tokenPrimaryOffer>,
};
